"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$dom = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utilities = require("./_utilities");

var _is_js = _interopRequireDefault(require("is_js"));

var $dom = function () {
  var localAPIs = {},
      defineContext = function defineContext(context) {
    var value = null;

    if (_is_js["default"].string(context)) {
      value = document.querySelector(context);
    } else if (_is_js["default"].domNode(context)) {
      value = context;
    } else if (_is_js["default"].undefined(context) || _is_js["default"]["null"](context)) {
      value = document;
    }

    if (value === null) (0, _utilities.warn)("The DOM-context for finding an element is not defined, context is specified as \"".concat(context, "\""), '$dom-helper');
    return value;
  },
      doWithClass = function doWithClass(target, className) {
    var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    className = (0, _utilities.filterStringArgs)(className);
    localAPIs.each(className, function (name) {
      return localAPIs.callAll(target, function (el) {
        return el.classList[action](name);
      });
    });
    return (0, _utilities.optimizeTarget)(target);
  },
      doWithInnerContent = function doWithInnerContent(target, options) {
    var results = [],
        setMode = _is_js["default"].not["null"](options.newContent);

    localAPIs.callAll(target, function (element) {
      if (_is_js["default"]["null"](options.newContent)) {
        results.push((0, _defineProperty2["default"])({
          element: element
        }, options.resultKey, element[options.resultMethod]));
      } else {
        element[options.resultMethod] = options.newContent;
      }
    });

    if (results.length === 0) {
      results = null;
    } else if (results.length === 1) {
      results = results[0][options.resultKey];
    }

    return setMode ? (0, _utilities.optimizeTarget)(target) : results;
  },
      doWithInsert = function doWithInsert(element, insertTarget, position) {
    if (!element || !insertTarget) return;
    if (_is_js["default"].string(element)) element = localAPIs.get(element);
    if (_is_js["default"].string(insertTarget)) insertTarget = localAPIs.get(insertTarget);
    var insertTargetElement;

    switch (position) {
      case 'after':
        insertTargetElement = insertTarget.nextSibling;
        break;

      case 'before':
        insertTargetElement = insertTarget;
        break;
    }

    insertTarget.parentNode.insertBefore(element, insertTargetElement);
    return element;
  },
      doWithAppend = function doWithAppend(target, element, position) {
    if (!element || !target) return;
    if (_is_js["default"].string(element)) element = localAPIs.get(element);
    if (_is_js["default"].string(target)) target = localAPIs.get(target);

    switch (position) {
      case 'start':
        target.insertBefore(element, target.childNodes[0] || null);
        break;

      case 'end':
        target.insertBefore(element, null);
        break;
    }

    return element;
  };

  localAPIs.get = function (selector, context) {
    context = defineContext(context);
    var target = null;

    try {
      target = context.querySelector(selector);
    } catch (e) {
      (0, _utilities.warn)("Could not find element by selector \"".concat(selector, "\" within context \"").concat(context, "\". A description of the original error follows"), e);
    }

    if (!(0, _utilities.isElement)(target)) (0, _utilities.warn)("Method \"get\" - element by selector \"".concat(selector, "\" not found"), '$dom-helper');
    return target;
  };

  localAPIs.getAll = function (selector, context) {
    context = defineContext(context);
    var target = [];

    try {
      target = Array.prototype.slice.call(context.querySelectorAll(selector));
    } catch (e) {
      (0, _utilities.warn)("Failed to execute array of elements by selector \"".concat(selector, "\" within context \"").concat(context, "\"\". A description of the original error follows"), e);
    }

    if (target.length === 0) (0, _utilities.warn)("Method \"getAll\" - array of elements by selector \"".concat(selector, "\" is empty"), '$dom-helper');
    return target;
  };

  localAPIs.each = function (collection, callback) {
    if (_is_js["default"].not.array(collection) || collection.length === 0) {
      (0, _utilities.warn)('Method each - collection is not a array or array is empty', '$dom-helper');
      return;
    }

    if (_is_js["default"].not["function"](callback)) {
      (0, _utilities.warn)('Method each - callback is not a function', '$dom-helper');
      return;
    }

    var l = collection.length;

    for (var i = 0; i < l; i++) {
      callback(collection[i], i);
    }

    return collection;
  };

  localAPIs.callAll = function (target, callback) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    if ((0, _utilities.isElement)(target) || (0, _utilities.isNode)(target) || target === window) {
      callback(target);
      return target;
    }

    if (_is_js["default"].string(target)) target = localAPIs.getAll(target, defineContext(context));

    if (_is_js["default"].array(target) && target.length > 0) {
      localAPIs.each(target, callback);
      return target;
    }

    return null;
  };

  localAPIs.addClass = function (target, className) {
    return doWithClass(target, className, 'add');
  };

  localAPIs.removeClass = function (target, className) {
    return doWithClass(target, className, 'remove');
  };

  localAPIs.hasClass = function (element, className) {
    return element.classList.contains(className);
  };

  localAPIs.toggleClass = function (target, className) {
    return doWithClass(target, className, 'toggle');
  };

  localAPIs.getParent = function (element) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (_is_js["default"].not["null"](selector)) {
      do {
        if (element.matches(selector)) return element;
        element = element.parentElement || element.parentNode;
      } while (element !== null && element.nodeType === 1);
    } else {
      return element.parentNode;
    }

    return null;
  };

  localAPIs.attr = function (target, property) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var results = [],
        setMode = _is_js["default"].string(property) && _is_js["default"].string(value) || _is_js["default"].object(property) && _is_js["default"].not["function"](property);

    localAPIs.callAll(target, function (element) {
      if (_is_js["default"].string(property)) {
        if (_is_js["default"]["null"](value)) {
          results.push({
            element: element,
            value: element.getAttribute(property)
          });
        } else if (_is_js["default"].string(value)) {
          element.setAttribute((0, _utilities.toDashesCase)(property), value);
        }
      } else if (_is_js["default"].object(property) && _is_js["default"].not["function"](property)) {
        for (var _i = 0, _Object$entries = Object.entries(property); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              _value = _Object$entries$_i[1];

          element.setAttribute((0, _utilities.toDashesCase)(key), _value);
        }
      }
    });

    if (results.length === 0) {
      results = null;
    } else if (results.length === 1) {
      results = results[0].value;
    }

    return setMode ? (0, _utilities.optimizeTarget)(target) : results;
  };

  localAPIs.html = function (target) {
    var newHtml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return doWithInnerContent(target, {
      newContent: newHtml,
      resultKey: 'html',
      resultMethod: 'innerHTML'
    });
  };

  localAPIs.text = function (target) {
    var newText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return doWithInnerContent(target, {
      newContent: newText,
      resultKey: 'text',
      resultMethod: 'textContent'
    });
  };

  localAPIs.createElement = function (tagName) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isSVG = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (_is_js["default"].not.string(tagName)) return;
    var el = isSVG ? document.createElementNS('http://www.w3.org/2000/svg', tagName) : document.createElement(tagName);

    if (attrs !== null && _is_js["default"].object(attrs) && _is_js["default"].not.array(attrs)) {
      for (var key in attrs) {
        if (attrs.hasOwnProperty(key)) {
          el.setAttribute(isSVG ? key : (0, _utilities.toDashesCase)(key), attrs[key]);
        }
      }
    }

    return el;
  };

  localAPIs.replace = function (element, newElement) {
    element.parentNode.replaceChild(newElement, element);
    return newElement;
  };

  localAPIs.wrap = function (element, wrapperElement) {
    element.parentNode.insertBefore(wrapperElement, element);
    wrapperElement.appendChild(element);
    return wrapperElement;
  };

  localAPIs.remove = function (target) {
    return localAPIs.callAll(target, function (element) {
      return element.parentNode.removeChild(element);
    });
  };

  localAPIs.insertAfter = function (element, insertTarget) {
    return doWithInsert(element, insertTarget, 'after');
  };

  localAPIs.insertBefore = function (element, insertTarget) {
    return doWithInsert(element, insertTarget, 'before');
  };

  localAPIs.append = function (appendTarget, element) {
    return doWithAppend(appendTarget, element, 'end');
  };

  localAPIs.prepend = function (prependTarget, element) {
    return doWithAppend(prependTarget, element, 'start');
  };

  localAPIs.clone = function (element) {
    return element.cloneNode(true);
  };

  localAPIs.ready = function (callback) {
    if (_is_js["default"].not["function"](callback)) {
      (0, _utilities.warn)('$dom.ready callback is not a function', '$dom-helper');
      return;
    }

    if (document.readyState === 'complete') callback();
    document.addEventListener('DOMContentLoaded', callback, {
      once: true
    });
  };

  return localAPIs;
}();

exports.$dom = $dom;